export const allowedDomains = [
    "localhost",
    "lhgeportal.com",
    "dev.lhgeportal.com",
    "stage.lhgeportal.com",
    "adminlhgeportal.com",
    "dev.adminlhgeportal.com",
    "stage.adminlhgeportal.com"
];
